import { render } from "./TooManyResults.vue?vue&type=template&id=62493e68&ts=true"
import script from "./TooManyResults.vue?vue&type=script&lang=ts"
export * from "./TooManyResults.vue?vue&type=script&lang=ts"

import exportComponent from "/build/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__